const tabButtons = document.querySelectorAll('.wine-tabs__header button[data-target]');

if (tabButtons.length) {
    const allPanels = document.querySelectorAll('.wine-tabs__content__panel');

    const activateTab = (btn) => {
        tabButtons.forEach(b => {
            b.classList.remove('active');
            b.setAttribute('aria-selected', 'false');
        });
        allPanels.forEach(p => p.classList.remove('open'));

        btn.classList.add('active');
        btn.setAttribute('aria-selected', 'true');
        document.getElementById(btn.dataset.target)?.classList.add('open');
    };

    tabButtons.forEach((btn, index) => {
        btn.addEventListener('click', () => activateTab(btn));

        btn.addEventListener('keydown', (e) => {
            let target = null;

            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                e.preventDefault();
                target = tabButtons[(index + 1) % tabButtons.length];
            } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                e.preventDefault();
                target = tabButtons[(index - 1 + tabButtons.length) % tabButtons.length];
            } else if (e.key === 'Home') {
                e.preventDefault();
                target = tabButtons[0];
            } else if (e.key === 'End') {
                e.preventDefault();
                target = tabButtons[tabButtons.length - 1];
            }

            if (target) {
                target.focus();
                activateTab(target);
            }
        });
    });

    activateTab(tabButtons[0]);
}
